export default "__VITE_ASSET__q6tfGKm3Qmt5DJmATeHQdA__"